var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotHhmtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.95 3.874a1.938 1.938 0 1 1 1.842-1.926A1.758 1.758 0 0 1 2.95 3.874ZM2.95 10.75a1.938 1.938 0 1 1 1.842-1.926A1.758 1.758 0 0 1 2.95 10.75ZM2.95 17.626A1.939 1.939 0 1 1 4.792 15.7a1.758 1.758 0 0 1-1.842 1.926Z",
    fill: "#4D5054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotHhmtIcon);
export default __webpack_public_path__ + "static/media/three-dot-hhmt-icon.59a7469f4443df6bc30d0a3a30ec3524.svg";
export { ForwardRef as ReactComponent };